<ion-item class="search-employee" #searchInput lines="full">
  <ion-input
    type="text"
    [value]="filterText"
    [placeholder]="'SEARCH_EMPLOYEE_BY_NAME' | translate"
    [disabled]="disabled"
    class="search-employee__input"
    debounce="300"
    (ionInput)="onSearchInputChange($event)"
    (ionFocus)="setInputFocused(true)"
  >
  </ion-input>
  <ion-icon
    *ngIf="selectedEmployee && !disabled"
    size="large"
    class="search-employee__clean-icon"
    name="close"
    (click)="clean()"
  ></ion-icon>
  <div item-end class="search-button" (click)="searchEmployee()">
    <ion-spinner
      *ngIf="isLoading"
      class="search-button__spinner"
      name="crescent"
    ></ion-spinner>
    <app-image
      *ngIf="!isLoading"
      class="search-button__icon"
      src="assets/icon/search.svg"
    ></app-image>
  </div>
</ion-item>
<ion-list *ngIf="shouldShowSearchResults()" class="employee-list">
  <ion-item
    *ngFor="let employee of employeesResults"
    class="item-employee"
    lines="none"
    (click)="onEmployeeSelect(employee)"
  >
    <app-image
      slot="start"
      class="avatar"
      src="assets/icon/default-avatar.png"
      [alt]="'ALT_IMG.AVATAR' | translate"
    ></app-image>
    <ion-label> {{ employee.firstName }} </ion-label>
  </ion-item>
</ion-list>
<div *ngIf="shouldShowNoResults()" class="search-employee__no-results">
  {{ 'SEARCH_EMPLOYEE_NO_RESULTS' | translate }}
</div>
